<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="project-cherry-pick-form">
    <div class="project-cherry-pick-form__body">
      <div
        v-if="formValidationErrors && Object.keys(formValidationErrors)?.length > 0"
        class="project-cherry-pick-form__body-errors mb-3"
      >
        <gf-custom-alert
          v-for="(error, index) in formValidationErrors"
          :key="index"
          variant="danger"
          class="mb-2"
        >
          <template #body>
            <b class="d-flex align-items-center">
              <i class="gf-icon gf-icon-alert mr-2"></i>
              <span v-html="error"></span>
            </b>
          </template>
        </gf-custom-alert>
      </div>
      <gf-custom-alert
        variant="info"
        class="mb-3"
      >
        <template #body>
          <b>
            <span>
              {{ $t('commit.cherryPick.description') }}
            </span>
          </b>
        </template>
      </gf-custom-alert>
      <div class="project-cherry-pick-form__body-branch">
        <div class="mb-3">
          <label>{{ $t('commit.cherryPick.pickInto') }}</label>
          <project-branch-selector
            v-model="form.selectedBranch"
            :alias="$route.params?.alias"
            :project-model="$route.params?.projectAlias"
            :select-default-branch="true"
            :error="formErrors.selectedBranch"
            style="max-width: 180px"
            @change="onSelectedBranchChange"
          />
        </div>
        <div class="mb-3">
          <label class="gf-custom-checkbox w-100">
            <input
              v-model="form.startMergeRequest"
              type="checkbox"
              @change="onMergeRequestCheckboxChange"
            />
            <span>{{ $t('commit.cherryPick.startMergeRequest') }}</span>
          </label>
          <input
            v-if="form.startMergeRequest"
            v-model="form.newBranchName"
            type="text"
            class="form-control form-control-sm w-100"
            :class="{ 'border-danger': formErrors.newBranchName }"
            :placeholder="$t('commit.cherryPick.newBranchName')"
            @input="onNewBranchNameInput"
          />
        </div>
      </div>
    </div>
    <div class="project-cherry-pick-form__footer">
      <button
        type="button"
        class="btn btn-dark btn-sm m-1"
        @click="cancel"
      >
        {{ $t('message.cancel') }}
      </button>
      <button
        type="button"
        class="btn btn-success btn-sm m-1"
        :disabled="checkFormErrors"
        @click="submit"
      >
        {{ $t('commit.cherryPick.pick') }}
      </button>
    </div>
  </div>
</template>

<script>
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import GfCustomAlert from '@/shared-modules/shared-components/shared/GfCustomAlert';
import CommitMessages from '@/shared-modules/modules/commit/commit.messages';
// eslint-disable-next-line max-len
import ProjectBranchSelector from '@/shared-modules/shared-components/shared/project-branch-selector';

export default {
  name: 'ProjectCherryPickForm',
  components: { GfCustomAlert, ProjectBranchSelector },
  data() {
    return {
      form: {
        startMergeRequest: false,
        selectedBranch: {},
        newBranchName: ''
      },
      formErrors: {
        selectedBranch: false,
        newBranchName: false
      }
    };
  },
  computed: {
    checkFormSelectedBranchErrors() {
      return Object.keys(this.form.selectedBranch)?.length === 0;
    },
    checkFormNewBranchNameErrors() {
      return this.form.newBranchName.length === 0;
    },
    checkFormErrors() {
      return this.form.startMergeRequest
        ? this.checkFormSelectedBranchErrors || this.checkFormNewBranchNameErrors
        : this.checkFormSelectedBranchErrors;
    },
    formValidationErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.CHERRY_PICK_FORM);
    }
  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit', this.form);
    },
    onSelectedBranchChange() {
      this.formErrors.selectedBranch = this.checkFormSelectedBranchErrors;
    },
    onNewBranchNameInput() {
      this.formErrors.newBranchName = this.checkFormNewBranchNameErrors;
    },
    onMergeRequestCheckboxChange() {
      this.form.newBranchName = '';
    }
  },
  i18n: { messages: CommitMessages }
};
</script>

<style lang="scss">
$this: '.project-cherry-pick-form';

#{$this} {
  #{$this}__body {
    &-branch {
      display: flex;
      flex-direction: column;

      & code {
        margin-top: 2px;
      }
    }
  }
  #{$this}__footer {
    padding-top: 8px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--border-color);
  }
}
</style>
